module.exports = __webpack_public_path__ + "img/Skills.ea99d248.svg";